<ng-content></ng-content>

<div class="mt-3">
    <ng-content select="[adaptCallToActionButton]"></ng-content>
    <a *ngIf="featureUrl"
       [routerLink]="featureUrl">Get started <i class="fal fa-angle-right"></i></a>
</div>
